import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { CmsComponentData, ICON_TYPE } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { ResetPasswordService, ResetPayload } from 'src/app/service/user/reset-password.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ResetPasswordComponent implements OnInit {
  data$: Observable<any[]> = this.componentData.data$;
  resetPasswordForm: FormGroup;
  resetToken: any;
  payload: ResetPayload = {
    newPassword: '',
    token: '',
  };
  err: boolean;
  errorMsg = '';
  errorMessage: any;
  isSuccess: boolean;
  header = document.querySelector('header');
  globalMsg = document.querySelector('cx-global-message');
  noMatch: boolean;
  isExpiredTokenPage = 0;
  iconTypes = ICON_TYPE;
  activeLanguage$: Observable<string> = this.languageService.getActive();

  constructor(
    protected componentData: CmsComponentData<any>,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private globalMessageService: GlobalMessageService,
    private resetService: ResetPasswordService,
    private cdr: ChangeDetectorRef,
    private languageService: ShimanoLanguageService,
    private router: Router
  ) {
    this.resetToken = this.activatedRoute.snapshot.queryParamMap.get('token');
  }

  ngOnInit() {
    this.data$.pipe(take(1)).subscribe((data) => data);
    this.isSuccess = false;
    this.noMatch = false;
    this.resetPasswordForm = this.formBuilder.group(
      {
        newPassword: [
          '',
          [
            Validators.required,
            Validators.pattern(
              '^(?=.*?[A-Z])(?=.*?[a-z])?(?=.*?[0-9])(?=.*?[_:#?!@$%^&*{}<>\\\\\\/()+=;\'"\\[\\]|,.~`-]).{8,}$'
            ),
          ],
        ],
        confirmPassword: ['', [Validators.required]],
      },
      { validator: this.mustMatch('newPassword', 'confirmPassword') }
    );
    this.checkToken();
  }

  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  checkToken() {
    this.payload.newPassword = null;
    this.payload.token = this.resetToken;
    this.resetService
      .validateToken(this.payload)
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.isExpiredTokenPage = 1;
          this.cdr.detectChanges();
        },
        () => {
          this.isExpiredTokenPage = 2;
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
          this.cdr.detectChanges();
        }
      );
  }

  resetPassword() {
    const newPassword = this.resetPasswordForm.controls.newPassword.value;
    const confirmPassword = this.resetPasswordForm.controls.confirmPassword.value;
    if (this.resetPasswordForm.invalid) {
      this.isSuccess = false;
      return;
    } else {
      this.payload.newPassword = newPassword;
      this.payload.token = this.resetToken;
      this.resetService
        .postChangePassword(this.payload)
        .pipe(take(1))
        .subscribe(
          (data) => {
            this.err = false;
            this.isSuccess = true;
            this.cdr.detectChanges();
            document.querySelector('.reset-password-main-pr').classList.add('d-none');
            document.querySelector('.forgot-reset-password-bottom-pr').classList.add('d-none');
          },
          () => {
            this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
            this.err = true;
            this.isSuccess = false;
            this.cdr.detectChanges();
          }
        );
    }
  }

  close($event: any) {
    if ($event) {
      this.err = false;
    }
  }

  goToLogin() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/login']);
    });
  }

  errorHandlr(error: any) {
    for (const er of error.error.errors) {
      if (!er.message) {
        er.message = '';
      }
      this.errorMsg = er.message;
    }

    this.err = true;
    // return throwError(errorMessage);
  }
}
